import { Component, OnChanges, Input } from 'angular-ts-decorators';
import { has } from 'lodash';
import {
  faCalendar,
  faCheck,
  faInfoCircle,
  faPencil,
  faPlus,
  faSave,
  faSpinner,
  faTimes,
  faTrash,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';

/**
 * A component that displays provided icon definition as svg
 * # Example
 * <pre>
 *   <sw-font-awesome icon="$ctrl.iconDefinition" [size="<number>"] [spin="<anything>"] [rotate="<number>"]>
 *   </sw-font-awesome>
 * </pre>
 * Where:
 * * *icon* - is icon definition object
 * * *name* - string. Allows for using named icons - the most common cases,
 * which we decided to include in the compnent itself to smoothen the migation.
 * * *size* - is the size of the icon, 2
 * * *spin* - boolean, if any value is provided the element will spin
 * * *rotate* - number, rotate the ement by the angle provided
 */
@Component({
  selector: 'swFontAwesome',
  template: require('./sw-font-awesome.html').default,
})
export class SwFontAwesomeComponent implements OnChanges {
  @Input() icon: IconDefinition;
  @Input('@') name: any;
  @Input('@') size: number | string;
  @Input('@') rotate: string;
  @Input('=') spin: any;

  style: object;
  svg: object;
  namedIcons: object;

  constructor(
    private $sce: ng.ISCEService,
    private fontawesome,
  ) {
    'ngInject';

    this.namedIcons = {
      'info-circle': faInfoCircle,
      times: faTimes,
      check: faCheck,
      'exclamation-triangle': require('@fortawesome/pro-solid-svg-icons')
        .faExclamationTriangle,
      spinner: faSpinner,
      trash: faTrash,
      save: faSave,
      plus: faPlus,
      pencil: faPencil,
      calendar: faCalendar,
    };
  }

  ngOnChanges() {
    let icon;

    if (angular.isDefined(this.name) && has(this.namedIcons, this.name)) {
      // check if we have named icon
      icon = this.namedIcons[this.name];
    } else if (angular.isDefined(this.icon)) {
      // use icon provide by icon argument
      icon = this.icon;
    }

    let html = '',
      size = this.size;

    // reimplement weird, but often use feature form old fa directive
    if (size === 'large') {
      size = 1.3;
    }

    if (icon) {
      html = this.fontawesome.icon(icon, {
        attributes: {
          size: angular.isDefined(size) ? size : 1,
        },
        classes: angular.isDefined(this.spin) ? ['fa-spin'] : [],
      }).html[0];
    } else {
      html = angular.isDefined(this.name) ? this.name : '';
    }

    this.style = {
      'font-size': angular.isDefined(size) ? `${size}em` : '',
      transform: angular.isDefined(this.rotate)
        ? `rotate(${this.rotate}deg)`
        : '',
    };

    this.svg = this.$sce.trustAsHtml(html);
  }
}
